module.exports = __webpack_public_path__ + "static/media/pokedex.16373c82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pokedex.jpg
// module id = 91
// module chunks = 0